export default "__VITE_ASSET__BiFfDvTt__"